export const SMS_EXTRA_ENTRIES = window.FKL.reSmsExtraEntries || 100;
export const COMPANY_FORM_EXTRA_ENTRIES = window.FKL.reCompanyFormExtraEntries || 25;
export const SMS_TNC_URL = window.FKL.reSmsTermsUrl || "https://www.findkeep.love/pages/terms";
export const SMS_PRIVACY_POLICY_URL =
  window.FKL.reSmsPrivacyPolicyUrl || "https://www.equippers.com/privacy-policy";
export const OFFER_TERMS_URL = window.FKL.reOfferTermsUrl || "https://www.equippers.com/offers";
export const LOGO_URL = "https://cdn.shopify.com/s/files/1/0265/0062/8528/files/re-logo.png?v=1769115759";
export const RE_WEBSITE_URL = "https://www.equippers.com";

export const SMS_FORM_TITLE = `Would you like to receive text messages and/or calls with special offers and promotions from Restaurant Equippers? Get ${SMS_EXTRA_ENTRIES} extra entries by opting-in.`;
export const COMPANY_FORM_TITLE = `Tell us about your business to get ${COMPANY_FORM_EXTRA_ENTRIES} extra entries`;
